import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

// import MyTaraQR from "../data/MyTara_App_QR.png";

import Navbar from './Navbar'

const KVSReportCard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlLang = searchParams.get("lang");

  const [lang, setLang] = useState(urlLang === "hi" ? "hi" : "en");

  return (
    <>
      <Navbar header={"KVS Report Card"}/>
      {/* <div className="mainContent"> */}
      <div className="kvsReportCard">
        {/* Language Switch */}
        <div className="lang-wrapper">
          <div className="lang-switch">
            <button
              className={`lang-btn ${lang === "en" ? "active" : ""}`}
              onClick={() => {
                setLang("en");
                setSearchParams({ lang: "en" });
              }}
            >
              English
            </button>

            <button
              className={`lang-btn ${lang === "hi" ? "active" : ""}`}
              onClick={() => {
                setLang("hi");
                setSearchParams({ lang: "hi" });
              }}
            >
              हिन्दी
            </button>
          </div>
        </div>

        <div className="card">
          {/* Heading */}
          <div className="heading">
            <h1>
              {lang === "en"
                ? "Oral Reading Fluency (ORF) Assessment"
                : "मौखिक पठन प्रवाह (ORF) मूल्यांकन"}
            </h1>

            <p>
              {lang === "en"
                ? "Information and resources for parents regarding the ORF assessment conducted in Kendriya Vidyalayas."
                : "केंद्रीय विद्यालयों में आयोजित ORF मूल्यांकन से संबंधित जानकारी और अभिभावकों के लिए संसाधन।"}
            </p>
          </div>

          {/* Content */}
          <div className="content">
            {/* English Content */}
            {lang === "en" && (
              <>
                <section>
                  <p className="bold">Dear Parent,</p>

                  <p>
                    We are writing to share with you an important update regarding
                    your child’s learning progress, which is closely aligned with
                    national education policies, such as the National Education
                    Policy (NEP) 2020 and the NIPUN Bharat Mission.
                  </p>

                  <p className="up-space">
                    As part of the evolving educational landscape, NEP 2020
                    envisions a holistic and inclusive approach to learning built
                    on the foundational skills of literacy and numeracy. These
                    foundational skills are critical for children’s overall
                    academic success, with Oral Reading Fluency (ORF) being
                    globally the most widely used measure of foundational literacy
                    skills in any language.{" "}
                    <span>
                      The assessment of ORF, combined with suitable instructional
                      strategies, is therefore a central component of a student’s
                      learning journey.
                    </span>
                  </p>

                  <p className="up-space">
                    With this letter, we are sharing with you the results of ORF
                    assessment, conducted in the school by the language teachers
                    (English and Hindi) using TARA, a tool developed by I.I.T.
                    Bombay. Please see below for an explanation of the ORF test
                    and how to access the results for your child.
                  </p>
                </section>

                <section>
                  <h2>What is Oral Reading Fluency and why is it important?</h2>

                  <p>
                    Oral reading fluency refers to the ability of the child to
                    read aloud any level-appropriate text with accuracy, speed,
                    and proper expression. It is a key indicator of a child's
                    reading ability and comprehension. More than just recognizing
                    words, reading fluency helps children to better understand and
                    internalize the text, and further enhancing their vocabulary,
                    critical thinking, and overall literacy skills. Children who
                    develop fluency in reading early are more likely to excel in
                    later stages of their education with their ability to learn
                    through reading.
                  </p>
                </section>

                <section>
                  <h2>How Do ORF Assessments Help Your Child?</h2>

                  <p>
                    Through periodic oral reading fluency assessments, teachers
                    can:
                  </p>

                  <ul>
                    <li>
                      Identify individual reading challenges and areas where extra
                      support may be needed.
                    </li>
                    <li>
                      Customize teaching strategies to cater to each child's
                      unique learning pace.
                    </li>
                    <li>
                      Track progress and ensure that students are on track to meet
                      age-appropriate literacy milestones.
                    </li>
                    <li>
                      Instill confidence in children by celebrating their
                      improvements, however small.
                    </li>
                  </ul>
                </section>

                <section>
                  <h2>Accessing Reading Reports and Intervention Materials</h2>

                  <p>
                    To keep you informed about your child’s progress, we are
                    sharing a detailed reading report card of your child that will
                    give you access to the following:
                  </p>

                  <ul>
                    <li>
                      <span>Oral Reading Fluency Reports:</span> These reports
                      will provide a detailed breakdown of your child’s fluency,
                      including metrics like reading speed, accuracy, and
                      expression. These metrics were obtained from the oral
                      reading by your child of a grade-level unseen passage.
                    </li>
                    <li>
                      <span>Intervention Materials:</span> For areas needing
                      improvement, we will provide you with intervention resources
                      (such as worksheets, reading exercises, and video tutorials)
                      that you can use at home to support your child’s progress.
                    </li>
                  </ul>

                  <p className="link-text">
                    <span>Click this link to access Intervention Videos:</span>{" "}
                    <a
                      href="https://docs.google.com/spreadsheets/d/1YfqHd1rG409lfiz-VHrvdHQ1o0b55BGQJ10REFcDA6E/edit?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      KVS Intervention Videos
                    </a>
                  </p>
                </section>

                <section>
                  <h2>What Does This Mean for You as Parents?</h2>
                  <p>
                    By actively participating in your child’s learning journey,
                    you can reinforce the importance of reading at home. Encourage
                    regular reading aloud practices and engage with your child’s
                    progress. It is critical that we work together in supporting
                    their literacy development.
                  </p>

                  <p className="up-space">
                    To assist you in your child's reading journey, we are pleased
                    to share that you are receiving early access to our app,
                    MyTARA, designed to help your child improve their reading
                    skills through guided practice and targeted support. The app
                    focuses on building key components of reading such as fluency,
                    accuracy, and expression. As an early access user, you will be
                    among the first to explore these features and support your
                    child’s reading journey in a more structured way. Please fill in the Google Form given below to express your interest for MyTARA.
                  </p>

                  {/* <p className="up-space">
                    <span>
                      Scan the QR code or click on the link to install the MyTARA
                      App to begin your child's reading journey from the comfort
                      of your home.
                    </span>
                  </p> */}

                  {/* <div className="qr-section">
                    <div className="qr-box">
                      <img src={MyTaraQR} alt="QR Code" />
                    </div>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.prosical.mytaraapp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Get it on Google Play"
                        className="playstore"
                      />
                    </a>
                  </div> */}

                  <p className="up-space">
                    We hope you will support this initiative, as it is a vital
                    part of your child’s educational journey. Together, we can
                    ensure that every child acquires the skills, confidence, and
                    joy of learning to read fluently.
                  </p>

                  <p className="up-space">
                    Thank you for your continued support and collaboration.
                  </p>

                  <p className="link-text">
                    <span>Click on this link to share your feedback regarding the TARA report card:</span>{" "}
                    <a
                      href="https://forms.gle/xpigb6wdKQB9ty818"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TARA Feedback Form (Parents/Guardians)
                    </a>
                  </p>

                  <p className="link-text">
                    <span>Click on this link to express your interest in using MyTARA:</span>{" "}
                    <a
                      href="https://forms.gle/bzgqw4qgohzk6q2X8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      MyTARA Expression of Interest Form
                    </a>
                  </p>
                </section>
              </>
            )}

            {/* Hindi Content */}
            {lang === "hi" && (
              <>
                <section>
                  <p className="bold">प्रिय अभिभावक, </p>

                  <p>
                    हम यह पत्र आपके बच्चे की सीखने की प्रगति के बारे में एक
                    महत्वपूर्ण जानकारी साझा करने के लिए लिख रहे हैं। जो की
                    राष्ट्रीय शिक्षा नीति NEP-2020 और निपुण भारत मिशन के साथ
                    निकटता से जुड़ा हुआ है।
                  </p>

                  <p className="up-space">
                    विकासशील शैक्षिक परिदृश्य के हिस्से के रूप में NEP-2020,
                    साक्षरता और संख्यात्मकता के आधारभूत कौशल पर आधारित, सीखने के
                    लिए एक समग्र और समावेशी दृष्टिकोण की कल्पना करता है। यह
                    आधारभूत कौशल बच्चों की समग्र शैक्षणिक सफलता के लिए महत्वपूर्ण
                    है। मौखिक पठन प्रवाह (ORF) किसी भी भाषा में आधारभूत साक्षरता
                    कौशल प्राप्ति का विश्व स्तर पर सबसे व्यापक रूप से इस्तेमाल
                    किया जाने वाला उपाय है।{" "}
                    <span>
                      इसलिए उपयुक्त अनुदेशात्मक रणनीतियों के साथ ओ आर एफ का
                      मूल्यांकन, छात्र की सीखने की यात्रा का एक केंद्रीय घटक है।
                    </span>
                  </p>

                  <p className="up-space">
                    इस पत्र के माध्यम से हम, आपके साथ ओ आर एफ मूल्यांकन के परिणाम
                    साझा कर रहे हैं, जो स्कूल में भाषा शिक्षकों (अंग्रेजी और
                    हिंदी) द्वारा तारा ऐप का उपयोग करके किया गया है, जो कि आईआईटी
                    मुंबई द्वारा विकसित एक उपकरण है। कृपया ORF परीक्षण के बारे में
                    स्पष्टीकरण और अपने बच्चों के लिए परिणाम प्राप्त करने के तरीके
                    के लिए नीचे देखें।
                  </p>
                </section>

                <section>
                  <h2>मौखिक पठन प्रवाह क्या है, और यह महत्वपूर्ण क्यों है?</h2>

                  <p>
                    मौखिक पठन प्रवाह से तात्पर्य बच्चों द्वारा अपने स्तर उपयुक्त
                    पाठ को सटीकता, गति और उचित स्वर लय के साथ शुद्ध रूप से पढ़ने
                    की क्षमता से है। यह बच्चे की पढ़ने की क्षमता और समझ का प्रमुख
                    संकेतक है। केवल शब्दों को पहचानने से कहीं अधिक, पढ़ने की
                    प्रवाहमयता बच्चों को, भाषा को बेहतर ढंग से समझने और आत्मसात
                    करने में मदद करती है। उनकी शब्दावली तथा आलोचनात्मक साक्षरता
                    कौशल को बढ़ाती है। जो बच्चे छोटी उम्र में पढ़ने में प्रवाह
                    विकसित करते हैं, उनके द्वारा इस माध्यम से सीखने की क्षमता के
                    साथ, उनकी शिक्षा के बाद के चरणों में उत्कृष्टता प्राप्त करने
                    की अधिक संभावना होती है।
                  </p>
                </section>

                <section>
                  <h2>मूल्यांकन आपके बच्चे की किस प्रकार मदद करता है?</h2>

                  <p>आवधिक मौखिक पठन प्रवाह मूल्यांकन के माध्यम से शिक्षक -</p>

                  <ul>
                    <li>
                      व्यक्तिगत पठन चुनौतियों और उन क्षेत्रों की पहचान करें जहां
                      अतिरिक्त सहायता की आवश्यकता हो।
                    </li>
                    <li>
                      प्रत्येक बच्चे की विशिष्ट सीखने की गति को ध्यान में रखते हुए
                      शिक्षक नीतियों को अनुकूलित करें।
                    </li>
                    <li>
                      प्रगति पर नजर रखें और सुनिश्चित करें, कि छात्र अपनी आयु के
                      लिए उपयुक्त साक्षरता लक्ष्य को प्राप्त करने की दिशा में आगे
                      बढ़ रहे हैं।
                    </li>
                    <li>
                      बच्चों की प्रगति का उत्सव मनाएं उनमें आत्मविश्वास पैदा करें,
                      चाहे वह प्रगति छोटी ही क्यों ना हो।
                    </li>
                  </ul>
                </section>

                <section>
                  <h2>पठन रिपोर्ट और पाठ्य सहायक सामग्री तक पहुंच</h2>

                  <p>
                    आपके बच्चे की प्रगति के बारे में आपको सूचित रखने के लिए हम
                    आपके बच्चे का विस्तृत रीडिंग रिपोर्ट कार्ड साझा कर रहे हैं,
                    जिससे आपको निम्नलिखित जानकारी प्राप्त होगी।
                  </p>

                  <ul>
                    <li>
                      मौखिक पठन प्रवाह रिपोर्ट आपके बच्चे की पठन प्रवाह शीलता का
                      विस्तृत ब्यौरा प्रदान करेगी। जिसमें पढ़ने की गति, सटीकता और
                      अभिव्यक्ति जैसे मापदंड शामिल होंगे। ये मापदंड आपके बच्चे
                      द्वारा ग्रेड-स्तर के अनदेखे अंश को मौखिक रूप से पढ़ने से
                      प्राप्त किए गए थे।
                    </li>
                    <li>
                      पाठ्य सहायक सामग्री - सुधार की आवश्यकता वाले क्षेत्र के लिए
                      हम आपको पाठ्य सहायक संसाधन, (जैसे कार्य पत्रक, पढ़ने के
                      अभ्यास और वीडियो ट्यूटोरियल्स) प्रदान करेंगे। जिनका उपयोग आप
                      अपने बच्चों की प्रगति का समर्थन करने के लिए घर पर कर सकते
                      हैं।
                    </li>
                  </ul>

                  <p className="link-text">
                    <span>
                      इंटरवेन्शन वीडियो देखने के लिए इस लिंक पर क्लिक करें:
                    </span>{" "}
                    <a
                      href="https://docs.google.com/spreadsheets/d/1YfqHd1rG409lfiz-VHrvdHQ1o0b55BGQJ10REFcDA6E/edit?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      KVS Intervention Videos
                    </a>
                  </p>
                </section>

                <section>
                  <h2>माता-पिता के रूप में आपके लिए इसका क्या अर्थ है?</h2>
                  <p>
                    अपने बच्चों की सीखने की यात्रा में सक्रिय रूप से भाग लेकर आप
                    घर पर पढ़ने के महत्व को सुदृढ़ कर सकते हैं। नियमित रूप से
                    शुद्धता से पढ़ने की आदत को प्रोत्साहित करें, और अपने बच्चों की
                    प्रगति में शामिल हों। यह महत्वपूर्ण है कि हम उनके साक्षरता
                    विकास का समर्थन करने के लिए मिलकर काम करें।
                  </p>

                  <p className="up-space">
                    आपके बच्चे के पढ़ने के सफर में आपकी सहायता करने के लिए, हमें
                    यह बताते हुए खुशी हो रही है कि आपको हमारे ऐप, MyTARA का अर्ली
                    एक्सेस मिल रहा है। यह ऐप आपके बच्चे को निर्देशित अभ्यास और
                    लक्षित सहायता के माध्यम से उनके पढ़ने के कौशल को बेहतर बनाने
                    में मदद करने के लिए डिज़ाइन किया गया है। ऐप पढ़ने के प्रमुख
                    घटकों जैसे प्रवाह, सटीकता और अभिव्यक्ति को विकसित करने पर
                    केंद्रित है। अर्ली एक्सेस उपयोगकर्ता के रूप में, आप इन
                    सुविधाओं का उपयोग करने वाले पहले लोगों में से होंगे और अपने
                    बच्चे के पढ़ने के सफर को अधिक व्यवस्थित तरीके से आगे बढ़ा
                    सकेंगे। कृपया MyTARA में अपनी रुचि व्यक्त करने के लिए नीचे दिए गए Google फॉर्म को भरें।
                  </p>

                  {/* <p className="up-space">
                    <span>
                      अपने बच्चे के पढ़ने के सफर को घर बैठे शुरू करने के लिए
                      MyTARA ऐप इंस्टॉल करने के लिए QR कोड स्कैन करें या लिंक पर
                      क्लिक करें।
                    </span>
                  </p> */}

                  {/* <div className="qr-section">
                    <div className="qr-box">
                      <img
                        src={MyTaraQR}
                        alt="QR Code"
                        className="w-full h-full object-contain"
                      />
                    </div>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.prosical.mytaraapp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Get it on Google Play"
                        className="playstore"
                      />
                    </a>
                  </div> */}

                  <p className="up-space">
                    हमें उम्मीद है कि आप इस पहल का समर्थन करेंगे, क्योंकि यह आपके
                    बच्चे की शिक्षा यात्रा का एक महत्वपूर्ण हिस्सा है। साथ मिलकर
                    हम यह सुनिश्चित कर सकते हैं कि हर बच्चा धारा प्रवाह पढ़ने के
                    कौशल को आत्मविश्वास और आनंद के साथ प्राप्त करे।
                  </p>

                  <p className="up-space">
                    आपके निरंतर समर्थन और सहयोग के लिए धन्यवाद।
                  </p>

                  <p className="link-text">
                    <span>
                      TARA रिपोर्ट कार्ड के संबंध में अपना फीडबैक शेयर करने के लिए इस लिंक पर क्लिक करें:
                    </span>{" "}
                    <a
                      href="https://forms.gle/xpigb6wdKQB9ty818"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TARA Feedback Form (Parents/Guardians)
                    </a>
                  </p>

                  <p className="link-text">
                    <span>MyTARA का उपयोग करने में अपनी रुचि व्यक्त करने के लिए इस लिंक पर क्लिक करें:</span>{" "}
                    <a
                      href="https://forms.gle/bzgqw4qgohzk6q2X8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      MyTARA रुचि व्यक्त करने का फॉर्म
                    </a>
                  </p>
                </section>
              </>
            )}
          </div>

          {/* Footer */}
          <div className="footer">
            <div>
              {lang === "en" ? "Team TARA," : "टीम टारा,"} <br />
              {lang === "en" ? "IIT Bombay" : "भारतीय प्रौद्योगिकी संस्थान मुंबई"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KVSReportCard;